import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformToolSpreadsheetHandler} from '@features/spreadsheet/services/platform-tool-spreadsheet-handler';
import {Api} from '@shared/constants/common-field.constants';
import { Subject } from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';


@Injectable({
  providedIn: 'root',
})
export class GenerateCbCNotificationGridHandler implements IPlatformToolHandler {

  invalidateSubject: InvalidateSubject;
  ngUnsubscribe = new Subject<void>();
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(
    private dialogService: DialogService,
    private platformToolSpreadsheetHandler: PlatformToolSpreadsheetHandler,
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private router: Router,
    private snackBarService: SnackBarService
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }

  executeCommand(command: PlatformCommand, callback?: any): boolean {
    this.executeCommandToApi(command);
    return true;
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          let templateId = commandResponse.fieldValues['TemplateId']
          let openCbcFormViewCommand = commandResponse.fieldValues['RedirectCommand']
          if (openCbcFormViewCommand) {
            openCbcFormViewCommand.fieldValues['TemplateId'] = templateId;
            this.platformToolSpreadsheetHandler.executeCommand(openCbcFormViewCommand, null);
            return;
          }

          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['SnackBarMessage']) {
            if (commandResponse.fieldValues['DeleteFlowTemplate']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            } else {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            }
          } else if (commandResponse.fieldValues['Error']) {
            const duration = commandResponse.fieldValues['Error'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['Error'], duration);
          }
        },

        error => {
          console.error('Failed CbcNotificationReportingLanguageSelector command', error);
          this.fuseSplashScreenService.hide();
        }
      );
    }
  }


  valueChanged($event) {
    let command = $event.dialogField?.fieldValues['Command'];
    let countryCode = $event.item?.cells['CountryCode']?.value;
    let viewItemId = $event.item?.cells['ViewItemId']?.value;
    let status = $event.item?.cells['Action']?.value;
    let entityCode = $event.item?.cells['EntityCode'].value;

    if (status === 'Generate') {
      let supportedCbCCountries = command.fieldValues['SupportedCbCCountries'];
      if (countryCode && supportedCbCCountries.includes(countryCode)) {
        this.dialogService.closeDialog({});
        command.fieldValues['CountryCode'] = countryCode;
        command.fieldValues['ViewItemId'] = viewItemId;
        command.fieldValues['EntityCode'] = entityCode;
        this.executeCommand(command);
      }
      else {
        let countryName = $event.item?.cells['Jurisdiction']?.value;
        let message = 'CbC Notifications for Australia are made as part of the Australia Local File. Go to Reports > Local Files and create a Country Specific Local File for Australia. Then complete Local File Other Information > CbC Report Lodgment Criteria and submit electronically to the ATO.';
        if (countryName !== 'Australia')
        {
          message = 'Auto filled notification forms for the ' + countryName + ' will be available in the next 2 to 4 weeks. Please go to CbC Forms tab to complete manually.';
        }
        this.dialogService.showDialogMessage('Warning!', message);
      }
    }
    else if (status === 'Open') {
      this.dialogService.closeDialog({});
      command.fieldValues['CountryCode'] = countryCode;
      command.fieldValues['ViewItemId'] = viewItemId;
      command.fieldValues['Status'] = status;
      command.fieldValues['EntityCode'] = entityCode;
      command.fieldValues['ReportingLanguage'] = $event.item?.cells['ReportingLanguage']?.value;
      this.executeCommand(command);
    }
    return;
  }

  destroy(): void {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setSelectedTab(selectedTab: TabModel): void {
  }


}
